module.exports = __webpack_public_path__ + "img/error-img.a7f6d013.png";